export default "__VITE_ASSET__7fbe34a5__"